import { render, staticRenderFns } from "./WorksList.vue?vue&type=template&id=a6cb5438&"
import script from "./WorksList.vue?vue&type=script&lang=js&"
export * from "./WorksList.vue?vue&type=script&lang=js&"
import style0 from "./WorksList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports